// @flow

import type { Action, State } from './types';

import {
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  FORGOT_PASSWORD_CLEAR_ERROR
} from './constants';

export const initialState: State = {
  error: false,
  requesting: false,
  success: false
};

const reducer = (state: State = initialState, action: Action) => {
  switch (action.type) {
    case FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        requesting: true,
        error: false,
        success: false
      };

    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        error: false,
        success: true,
        requesting: false
      };

    case FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        requesting: false,
        success: false,
        error: true
      };

    case FORGOT_PASSWORD_CLEAR_ERROR:
      return {
        ...initialState
      };

    default:
      return state;
  }
};

export default reducer;
